export const state = () => ({
  meta: null,
  stage: null,
  intro: null,
  trusts: null,
  career: null,
  crossLinkage: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  intro(state) {
    return state.intro
  },
  trusts(state) {
    return state.trusts
  },
  career(state) {
    return state.career
  },
  crossLinkage(state) {
    return state.crossLinkage
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setIntro(state, { data }) {
    state.intro = data
  },
  setTrusts(state, { data }) {
    state.trusts = data
  },
  setCareer(state, { data }) {
    state.career = data
  },
  setCrossLinkage(state, { data }) {
    state.crossLinkage = data
  }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/unternehmen/ueber-uns/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/unternehmen/ueber-uns/stage.json`)
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getIntro({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/unternehmen/ueber-uns/intro.json`)
      .then((res) => {
        commit('setIntro', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getTrusts({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/unternehmen/ueber-uns/trusts.json`)
      .then((res) => {
        commit('setTrusts', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getCareer({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/unternehmen/ueber-uns/career.json`)
      .then((res) => {
        commit('setCareer', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getCrossLinkage({ commit, rootState }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/unternehmen/ueber-uns/cross_linkage.json`
      )
      .then((res) => {
        commit('setCrossLinkage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
